import { format } from 'date-fns';
import type { Task, ProgressUpdate } from '../types';

export interface SubtaskEntry {
  task: Task;
  update: ProgressUpdate;
}

export interface DayActivity {
  parentTask: Task;
  entries: SubtaskEntry[];
  parentCompleted: boolean;
}

export function computeDayActivities(
  allTasks: Task[],
  allProgressUpdates: ProgressUpdate[],
  dateStr: string
): DayActivity[] {
  const taskMap = new Map(allTasks.map((t) => [t.id, t]));
  const parentTasks = allTasks.filter((t) => !t.parentId);
  const parentMap = new Map(parentTasks.map((t) => [t.id, t]));
  const activities = new Map<string, DayActivity>();

  const dayUpdates = allProgressUpdates
    .filter((u) => format(new Date(u.createdAt), 'yyyy-MM-dd') === dateStr)
    .sort((a, b) => a.createdAt.localeCompare(b.createdAt));

  for (const update of dayUpdates) {
    const task = taskMap.get(update.taskId);
    if (!task || !task.parentId) continue;
    const parent = parentMap.get(task.parentId);
    if (!parent) continue;
    if (!activities.has(parent.id)) {
      activities.set(parent.id, { parentTask: parent, entries: [], parentCompleted: false });
    }
    activities.get(parent.id)!.entries.push({ task, update });
  }

  for (const parent of parentTasks) {
    if (parent.status === 'done' && parent.completedAt && format(new Date(parent.completedAt), 'yyyy-MM-dd') === dateStr) {
      if (!activities.has(parent.id)) {
        activities.set(parent.id, { parentTask: parent, entries: [], parentCompleted: true });
      } else {
        activities.get(parent.id)!.parentCompleted = true;
      }
    }
  }

  return Array.from(activities.values());
}
